import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import SuperAdminNavbar from "../Components/Superadminnavbar";
import {
  Button,
  Input,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import { useDataContext } from "../Context/dataContext";
import { NotFound } from "./NotFound";

function Relation() {
  const { url, infoTkn } = useDataContext();
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [activeTab, setActiveTab] = useState("TODO");
  const [newBolivarRate, setNewBolivarRate] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const [admin, setAdmin] = useState({});
  const [ordersByAdmin, setOrdersByAdmin] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [currency, setCurrency] = useState([]);

  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [currencyBs, setCurrencyBs] = useState([]);

  const fetchCurrencyBs = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/currency-price/1`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setCurrencyBs(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, url]);

  // fetchSadm
  const fetchDataSadmin = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTSuperAdmin/${infoTkn}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setAdmin(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, url]);

  // fetchAdmins
  const fetchAdmins = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/Movements/allByAdminReverted`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setAdmins(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, url]);

  // Currency
  const fetchCurrency = async () => {
    try {
      const response = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=eur"
      );
      setCurrency(response.data.tether.eur);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchOrderByAdmin = async (adminId) => {
    try {
      const response = await axios.get(`${url}/Movements/admin/${adminId}`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setOrdersByAdmin(response.data);

      const responseAdm = await axios.get(`${url}/Admin/${adminId}`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setSelectedAdmin(responseAdm.data);
    } catch (error) {
      console.log(error);
    }
  };

  const groupedOrders = ordersByAdmin
    .filter((order) => {
      if (order.mov_status !== "V") {
        return false;
      }

      if (startDate && endDate) {
        return (
          new Date(order.mov_paymentDate) >= new Date(startDate) &&
          new Date(order.mov_paymentDate) <= new Date(endDate)
        );
      } else if (startDate) {
        return new Date(order.mov_paymentDate) >= new Date(startDate);
      } else if (endDate) {
        return new Date(order.mov_paymentDate) <= new Date(endDate);
      } else {
        return true;
      }
    })
    .reduce((acc, order) => {
      const userId = order.User.use_id;
      const conversionType = order.mov_conversionType;
      const key = `${userId}-${conversionType}`;

      if (!acc[key]) {
        acc[key] = {
          user: `${order.User.use_name} ${order.User.use_lastName}`,
          totalAmount: 0,
          totalAmountBs: 0,
          totalAmountUsdt: 0,
          conversionType: conversionType,
          status: order.User.use_verif,
          wallet: selectedAdmin ? selectedAdmin.adm_wallet : "", // Añadir el campo wallet
        };
      }
      acc[key].totalAmount += order.mov_amount;
      conversionType === "Bs"
        ? (acc[key].totalAmountBs += order.mov_paymentAmount)
        : (acc[key].totalAmountUsdt += order.mov_paymentAmount);
      return acc;
    }, {});

  // Cambiar tasa de bolívares con confirmación
  const handleConfirmRateChange = async () => {
    try {
      await axios.put(
        `${url}/currency-price`,
        {
          cur_bs: newBolivarRate,
        },
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      fetchCurrencyBs();
      setModalOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDataSadmin();
    fetchAdmins();
    fetchCurrency();
    fetchCurrencyBs();
  }, [fetchDataSadmin, fetchAdmins, fetchCurrencyBs]);

  const totalAmounts = Object.keys(groupedOrders).reduce(
    (totals, key) => {
      const order = groupedOrders[key];
      totals.totalEuros += order.totalAmount;
      if (order.conversionType === "Bs") {
        totals.totalBs += order.totalAmountBs;
      } else if (order.conversionType === "Usdt") {
        totals.totalUsdt += order.totalAmountUsdt;
      }
      return totals;
    },
    { totalEuros: 0, totalBs: 0, totalUsdt: 0 }
  );

  return admin ? (
    <div>
      <SuperAdminNavbar />
      <div className="relation-container">
        <h2 className="relation-title">Gestión de Transacciones Aprobadas</h2>

        {/* Filtro de fechas */}
        <div className="date-filter">
          <div className="date-filter__field">
            <label htmlFor="start-date">Desde:</label>
            <Input
              type="date"
              id="start-date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="date-filter__field">
            <label htmlFor="end-date">Hasta:</label>
            <Input
              type="date"
              id="end-date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <Button
            className="date-filter__button"
            onClick={() => window.location.reload()}
          >
            Limpiar
          </Button>
        </div>

        {/* Filtro por Administrador */}
        <div className="admin-filter">
          <label>Relación por Administrador:</label>
          <Select
            className="select-admin"
            options={admins.map((admin) => ({
              value: admin.adm_id,
              label: `${admin.adm_name} ${admin.adm_lastname} - ${admin.adm_user}`,
            }))}
            placeholder="Seleccione un administrador..."
            onChange={(e) => fetchOrderByAdmin(e.value)}
            isSearchable
          />
        </div>

        <div className="bolivar-rate">
          <Input
            type="number"
            defaultValue={currencyBs.cur_bs}
            onChange={(e) => setNewBolivarRate(e.target.value)}
          />
          <Button color="warning" onClick={() => setModalOpen(true)}>
            Cambiar Tasa
          </Button>
        </div>

        {/* Tabs TODO / USDT / BOLÍVARES */}
        <div className="relation-tabs">
          <Button
            className={activeTab === "TODO" ? "active" : ""}
            onClick={() => setActiveTab("TODO")}
          >
            TODO
          </Button>
          <Button
            className={activeTab === "USDT" ? "active" : ""}
            onClick={() => setActiveTab("USDT")}
          >
            USDT
          </Button>
          <Button
            className={activeTab === "BOLIVARES" ? "active" : ""}
            onClick={() => setActiveTab("BOLIVARES")}
          >
            BOLÍVARES
          </Button>
        </div>

        {/* TABLA TODO */}
        {activeTab === "TODO" && (
          <Table className="relation-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuario</th>
                <th>Monto (€)</th>
                <th>Moneda</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedOrders).map((key, index) => (
                <tr key={key}>
                  <td>{index + 1}</td>
                  <td>{groupedOrders[key].user}</td>
                  <td>€ {groupedOrders[key].totalAmount.toFixed(2)}</td>
                  <td>{groupedOrders[key].conversionType}</td>
                  <td className={`status status-${groupedOrders[key].status}`}>
                    {groupedOrders[key].status === "P"
                      ? "Pendiente"
                      : groupedOrders[key].status === "S"
                      ? "Verificado"
                      : "Rechazado"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        {/* TABLA USDT */}
        {activeTab === "USDT" && (
          <Table className="relation-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuario</th>
                <th>Monto (€)</th>
                <th>Wallet</th>
                <th>Tasa Oficial</th>
                <th>Tasa Objetiva</th>
                <th>Total en Usdt</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedOrders)
                .filter((key) => groupedOrders[key].conversionType === "Usdt")
                .map((key, index) => (
                  <tr key={key}>
                    <td>{index + 1}</td>
                    <td>{groupedOrders[key].user}</td>
                    <td>€ {groupedOrders[key].totalAmount.toFixed(2)}</td>
                    <td>{groupedOrders[key].wallet}</td>
                    <td>{currency}</td>
                    <td>{currency * selectedAdmin.adm_porcent + currency}</td>
                    <td>{groupedOrders[key].totalAmountUsdt.toFixed(2)}</td>
                    <td
                      className={`status status-${groupedOrders[key].status}`}
                    >
                      {groupedOrders[key].status === "P"
                        ? "Pendiente"
                        : groupedOrders[key].status === "S"
                        ? "Verificado"
                        : "Rechazado"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}

        {/* TABLA BOLÍVARES */}
        {activeTab === "BOLIVARES" && (
          <Table className="relation-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuario</th>
                <th>Monto (€)</th>
                <th>Tasa en Bolívares</th>
                <th>Total en Bs</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedOrders)
                .filter((key) => groupedOrders[key].conversionType === "Bs")
                .map((key, index) => (
                  <tr key={key}>
                    <td>{index + 1}</td>
                    <td>{groupedOrders[key].user}</td>
                    <td>€ {groupedOrders[key].totalAmount.toFixed(2)}</td>
                    <td>{currencyBs.cur_bs} Bs</td>
                    <td>{groupedOrders[key].totalAmountBs.toFixed(2)} Bs</td>
                    <td
                      className={`status status-${groupedOrders[key].status}`}
                    >
                      {groupedOrders[key].status === "P"
                        ? "Pendiente"
                        : groupedOrders[key].status === "S"
                        ? "Verificado"
                        : "Rechazado"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}

        <div className="totals-summary">
          <h4>Totales Generales</h4>
          <p>Total en Euros (€): € {totalAmounts.totalEuros.toFixed(2)}</p>
          <p>Total en Bolívares (Bs): {totalAmounts.totalBs.toFixed(2)} Bs</p>
          <p>Total en USDT: {totalAmounts.totalUsdt.toFixed(2)} USDT</p>
        </div>

        {/* Modal de confirmación */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
          <ModalHeader toggle={() => setModalOpen(false)}>
            Confirmar Cambio de Tasa
          </ModalHeader>
          <ModalBody>
            ¿Estás seguro de cambiar la tasa de bolívares a {newBolivarRate} Bs?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => setModalOpen(false)}>
              Cancelar
            </Button>
            <Button color="success" onClick={handleConfirmRateChange}>
              Confirmar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  ) : (
    <NotFound />
  );
}

export { Relation };
